// src/api/fileService.js
import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/metadata`;

// Create axios instance with authentication
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // Adjust based on your auth implementation
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized access
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const fetchComprehensiveStats = async () => {
  try {
    const response = await api.get(`/ayah/comprehensive-stats`);
    return response.data;
  } catch (error) {
    console.error('Error fetching comprehensive stats:', error);
    throw error;
  }
};


/**
 * Verifier report for one translation, grouped by surah.
 * @returns {Promise<{translation_info_id, totals, summary}>}
 */
export const fetchTranslationReport = async (translationInfoId) => {
  try {
    const response = await api.get(`/translation/comprehensive-stats`, {
      params: { translation_info_id: translationInfoId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching translation report:', error);
    throw error;
  }
};
